export default "__VITE_ASSET__DJQQ1YYN__"